import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../components/apiconfig/api-config';

const ProtectedRoute = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await axios.get(`${API_BASE_URL}/api/auth/protected`, {
          withCredentials: true,
        });
        setIsAuthenticated(true);
      } catch (err) {
        // If unauthorized, try to refresh token
        if (err.response && (err.response.status === 401 || err.response.status === 403)) {
          try {
            await axios.post(`${API_BASE_URL}/api/auth/refresh-token`, {}, { withCredentials: true });
            // Try again after refresh
            await axios.get(`${API_BASE_URL}/api/auth/protected`, { withCredentials: true });
            setIsAuthenticated(true);
            return;
          } catch {
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(false);
        }
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, []);

  // Only render loading or redirect, never children until authChecked is true
  if (!authChecked) {
    return <div className="text-center mt-20 text-blue-600">Checking authentication...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
